class SpiBox {
    constructor(mainSelector, selectors) {
        let defaultSelectors = {
            down: ".spin-box__down",
            input: ".spin-box__input",
            up: ".spin-box__up",
            disabledBtn: "spin-box__btn--disabled"
        };

        this.selectors = Object.assign(defaultSelectors, selectors);

        this.spinBoxes = document.querySelectorAll(mainSelector);

        if (this.spinBoxes != null)
            this.event();
    }

    state = (input, down) => {
        (input.value == 1) ? down.classList.add(this.selectors.disabledBtn)
            : down.classList.remove(this.selectors.disabledBtn);
    }

    event() {
        this.spinBoxes.forEach(e => {
            const btnDown = e.querySelector(this.selectors.down);
            const input = e.querySelector(this.selectors.input);
            const btnUp = e.querySelector(this.selectors.up);

            this.state(input, btnDown);

            input.addEventListener('keypress', (e) => {
                (/^[0-9]$/i.test(e.key) == false) ? e.preventDefault() : e.key;
            });

            input.addEventListener('keyup', (e) => {
                if (e.currentTarget.value == '0')
                    e.currentTarget.value = 1;

                this.state(input, btnDown);
            });

            input.addEventListener('change', (e) => {
                if (!e.currentTarget.value)
                    e.currentTarget.value = 1;

                this.state(input, btnDown);
            });

            btnUp.addEventListener('mousedown', (e) => {
                let interval = setInterval(() => {
                    ++input.value;
                }, 150);

                btnUp.addEventListener('mouseout', () => { clearInterval(interval); });
                btnUp.addEventListener('mouseup', () => { clearInterval(interval); });

                this.state(input, btnDown);
            });

            btnUp.addEventListener('click', (e) => {
                ++input.value;

                this.state(input, btnDown);
            });


            btnDown.addEventListener('mousedown', (e) => {
                let interval = setInterval(() => {
                    if (input.value > 1)
                        --input.value;
                }, 120);

                btnDown.addEventListener('mouseout', () => { clearInterval(interval); });
                btnDown.addEventListener('mouseup', () => { clearInterval(interval); });

                this.state(input, btnDown);
            });

            btnDown.addEventListener('click', () => {
                if (input.value > 1)
                    --input.value;

                this.state(input, btnDown);
            });
        });
    }
}